import styled from 'styled-components'

export const Container = styled.div`
  width: auto;
  display: flex;
  flex-direction: row;
  background-color: #fbfbfb;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
  max-height: 120px;
  max-width: 400px;

  &:hover {
    opacity: 0.8;
  }
`

export const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 150px;
  height: 120px;
  border-bottom-left-radius: 16px;
`

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export const TextContainer = styled.div`
  width: 95%;
  padding: 0px 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`

export const TitleContainer = styled.div`
  width: auto;
  height: 50%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  @media (max-width: 480px) {
    h4 {
      font-size: 1rem;
    }
  }
`
